"use strict";

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _document = require("../document");

var _document2 = _interopRequireDefault(_document);

var _part = require("./part");

var _part2 = _interopRequireDefault(_part);

var _color = require("color");

var _color2 = _interopRequireDefault(_color);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var _class = function (_Base) {
	_inherits(_class, _Base);

	function _class() {
		_classCallCheck(this, _class);

		var _this = _possibleConstructorReturn(this, (_class.__proto__ || Object.getPrototypeOf(_class)).apply(this, arguments));

		_this.main = new _part2.default("", _this);
		_this.officeDocument = new _this.constructor.OfficeDocument(_this.main.getRelTarget("officeDocument"), _this);
		return _this;
	}

	_createClass(_class, [{
		key: "render",
		value: function render() {
			var _officeDocument;

			return (_officeDocument = this.officeDocument).render.apply(_officeDocument, arguments);
		}
	}, {
		key: "parse",
		value: function parse() {
			var _officeDocument2;

			return (_officeDocument2 = this.officeDocument).parse.apply(_officeDocument2, arguments);
		}
	}, {
		key: "dxa2Px",
		value: function dxa2Px(a) {
			return this.pt2Px(parseInt(a) / 20.0);
		}
	}, {
		key: "emu2Px",
		value: function emu2Px(a) {
			return this.pt2Px(parseInt(a) / 12700);
		}
	}, {
		key: "pt2Px",
		value: function pt2Px(pt) {
			return Math.ceil(pt * 96 / 72);
		}
	}, {
		key: "cm2Px",
		value: function cm2Px(cm) {
			return this.pt2Px(parseInt(cm) * 28.3464567 / 360000);
		}
	}, {
		key: "asColor",
		value: function asColor(v, transform) {
			if (!v || v.length == 0 || v == 'auto') return '#000000';
			v = v.split(' ')[0];
			var rgb = v.charAt(0) == '#' ? v : RGB.test(v) ? '#' + v : v;
			if (transform) {
				var lumMod = transform.lumMod,
				    lumOff = transform.lumOff,
				    tint = transform.tint,
				    shade = transform.shade;

				if (lumMod || lumOff || tint) {
					var color = (0, _color2.default)(rgb);

					if (tint != undefined) {
						color = color.lighten(1 - tint);
					}

					if (lumMod != undefined) {
						color = color.lighten(lumMod);
					}

					if (lumOff != undefined) {
						color = color.darken(lumOff);
					}

					if (shade != undefined) {
						color = color.red(color.red() * (1 + shade)).green(color.green() * (1 + shade)).blue(color.blue() * (1 + shade));
					}

					return ("" + color.hex()).replace(/^0x/, "#");
				}
			}
			return rgb;
		}
	}, {
		key: "toPx",
		value: function toPx(length) {
			var value = parseFloat(length),
			    units = String(length).match(RE_LENGTH_UNIT)[2];

			switch (units) {
				case 'em':
					return value * 16;
				case 'rem':
					return value * 16;
				case 'cm':
					return value * 96 / 2.54;
				case 'mm':
					return value * 96 / 2.54 / 10;
				case 'in':
					return value * 96;
				case 'pt':
					return value * 72;
				case 'pc':
					return value * 72 / 12;
				default:
					return value;
			}
		}
	}, {
		key: "vender",
		get: function get() {
			"Microsoft";
		}
	}, {
		key: "product",
		get: function get() {
			return 'Office 2010';
		}
	}, {
		key: "contentTypes",
		get: function get() {
			return this.getObjectPart("[Content_Types].xml")("Types");
		}
	}]);

	return _class;
}(_document2.default);

_class.OfficeDocument = _part2.default;
exports.default = _class;

var RGB = /([a-fA-F0-9]{2}?){3}?/;
var RE_LENGTH_UNIT = /^(\d+)(\w)+$/;
module.exports = exports['default'];
//# sourceMappingURL=data:application/json;base64,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